module.exports = __webpack_public_path__ + "static/img/banner-about-02.b25f5f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-about-02.jpg
// module id = Abze
// module chunks = 99